import React, { useState, useEffect } from 'react';
import axiosInstance from '../../../axiosInstance.js';
import { Link } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";
import './Panel.css';
import {SideBar} from "../SideBar/SideBar.js";
import { Navbar } from '../Navbar/Navbar.js';
import { Button, Checkbox, Label, TextInput } from "flowbite-react";


const NavPanel = () => {
  const [navbarItems, setNavbarItems] = useState([]);
  const [contactInfo, setContactInfo] = useState({});
  const [socialLinks, setSocialLinks] = useState([]);
  const [logo, setLogo] = useState({});
  const [formData, setFormData] = useState({ title: '', url: '', position: '' });
  const [editingItemId, setEditingItemId] = useState(null);

  useEffect(() => {
    fetchNavbarItems();
    fetchContactInfo();
    fetchSocialLinks();
    fetchLogo();
  }, []);

  const fetchNavbarItems = async () => {
    try {
      const response = await axiosInstance.get('/navbar/content');
      setNavbarItems(response.data);
    } catch (error) {
      console.error('Error fetching navbar items:', error);
    }
  };
  
  const fetchContactInfo = async () => {
    try {
      const response = await axiosInstance.get('/navbar/contact-info');
      setContactInfo(response.data);
    } catch (error) {
      console.error('Error fetching contact info:', error);
    }
  };

  const fetchSocialLinks = async () => {
    try {
      const response = await axiosInstance.get('/navbar/social-links');
      setSocialLinks(response.data);
    } catch (error) {
      console.error('Error fetching social links:', error);
    }
  };

  const fetchLogo = async () => {
    try {
      const response = await axiosInstance.get('/navbar/logo');
      setLogo(response.data);
    } catch (error) {
      console.error('Error fetching logo:', error);
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleContactInfoChange = (e) => {
    setContactInfo({ ...contactInfo, [e.target.name]: e.target.value });
  };


  const handleCreate = async (e) => {
    e.preventDefault();
    try {
      const response = await axiosInstance.post('/navbar/upload', formData, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      if (response.status === 200) {
        await fetchNavbarItems();
        setFormData({ title: '', url: '', position: '' });
      } else {
        console.error('Create failed:', response.statusText);
      }
    } catch (error) {
      console.error('Create error:', error);
    }
  };

  const handleEdit = (itemId) => {
    const itemToEdit = navbarItems.find(item => item._id === itemId);
    if (itemToEdit) {
      setFormData({ title: itemToEdit.title, url: itemToEdit.url, position: itemToEdit.position });
      setEditingItemId(itemId);
    }
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    try {
      const response = await axiosInstance.put(`/navbar/${editingItemId}`, formData, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      if (response.status === 200) {
        await fetchNavbarItems();
        setFormData({ title: '', url: '', position: '' });
        setEditingItemId(null);
      } else {
        console.error('Update failed:', response.statusText);
      }
    } catch (error) {
      console.error('Update error:', error);
    }
  };

  const handleDelete = async (itemId) => {
    try {
      const response = await axiosInstance.delete(`/navbar/${itemId}`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      if (response.status === 200) {
        await fetchNavbarItems();
      } else {
        console.error('Delete failed:', response.statusText);
      }
    } catch (error) {
      console.error('Delete error:', error);
    }
  };

  const handleContactInfoUpdate = async (e) => {
    e.preventDefault();
    try {
      const response = await axiosInstance.post('/navbar/contact-info', contactInfo, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      if (response.status === 200) {
        await fetchContactInfo();
      } else {
        console.error('Update failed:', response.statusText);
      }
    } catch (error) {
      console.error('Update error:', error);
    }
  };

  const handleSocialLinkEdit = (itemId) => {
    const linkToEdit = socialLinks.find(link => link._id === itemId);
    if (linkToEdit) {
      setFormData({ url: linkToEdit.url, icon: linkToEdit.icon });
      setEditingItemId(itemId);
    }
  };

  const handleSocialLinkUpdate = async (e) => {
    e.preventDefault();
    try {
      const response = await axiosInstance.put(`/navbar/social-links/${editingItemId}`, formData, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      if (response.status === 200) {
        await fetchSocialLinks();
        setFormData({ url: '', icon: '' });
        setEditingItemId(null);
      } else {
        console.error('Update failed:', response.statusText);
      }
    } catch (error) {
      console.error('Update error:', error);
    }
  };

  const handleLogoUpload = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('image', e.target.logo.files[0]);

    try {
      const response = await axiosInstance.post('/navbar/logo', formData, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });

      if (response.status === 200) {
        await fetchLogo();
      } else {
        console.error('Logo upload failed:', response.statusText);
      }
    } catch (error) {
      console.error('Logo upload error:', error);
    }
  };

  const handleLogoEdit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('image', e.target.logo.files[0]);

    try {
      const response = await axiosInstance.put(`navbar/logo/${logo._id}`, formData, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });

      if (response.status === 200) {
        await fetchLogo();
      } else {
        console.error('Logo update failed:', response.statusText);
      }
    } catch (error) {
      console.error('Logo update error:', error);
    }
  };

  return (
    <>
<div className="flex">
  {/* Sidebar */}
    <SideBar />
 
  {/* Main Content */}
  <div className="flex-1 p-6 overflow-auto bg-gray-100">
    <div className="max-w-3xl mx-auto panel-container">
      <div className="panel-form bg-white p-8 rounded-lg shadow-xl">
        <h2 className="admin-nav-heading text-2xl font-semibold mb-6 text-gray-800">Navbar Panel</h2>
        <form className="space-y-6" onSubmit={editingItemId ? handleUpdate : handleCreate}>
          
          {/* Title Input */}
          <div>
            <input
              type="text"
              name="title"
              value={formData.title}
              onChange={handleChange}
              placeholder="Title"
              required
              className="w-full p-4  border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          
          {/* Password Input */}
          {/* <div>
            <input
              type="password"
              id="password1"
              placeholder="Password"
              className="w-full p-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
           */}
          {/* URL Input */}
          <div>
            <input
              type="text"
              name="url"
              value={formData.url}
              onChange={handleChange}
              placeholder="URL"
              required
              className="w-full p-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          
          {/* Position Input */}
          <div>
            <input
              type="number"
              name="position"
              value={formData.position}
              onChange={handleChange}
              placeholder="Position"
              required
              className="w-full p-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          
          {/* Submit Button */}
          <div className="flex justify-end">
            <button
              type="submit"
                className="px-6 py-3 bg-blue-500 text-white font-semibold rounded-lg hover:bg-blue-600 transition-colors duration-300"  
            >
              {editingItemId ? 'Update' : 'Create'}
            </button>
          </div>
        </form>
          {/* Contact Info Form */}
          <form className="admin-form" onSubmit={handleContactInfoUpdate}>
          <input               className="w-full p-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
 type="text" name="phone" value={contactInfo.phone || ''} onChange={handleContactInfoChange} placeholder="Phone" required />
          <input                className="w-full p-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
 type="text" name="email" value={contactInfo.email || ''} onChange={handleContactInfoChange} placeholder="Email" required />
          <button                 className="px-6 py-3 bg-blue-500 text-white font-semibold rounded-lg hover:bg-blue-600 transition-colors duration-300"  
 type="submit">Update Contact Info</button>
        </form>
        
        {/* Social Links Form */}
        <form className="admin-form" onSubmit={handleSocialLinkUpdate}>
          <input               className="w-full p-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
 type="text" name="url" value={formData.url} onChange={handleChange} placeholder="URL" required />
          <input                className="w-full p-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
type="text" name="icon" value={formData.icon} onChange={handleChange} placeholder="Icon" required />
          <button                  className="px-6 py-3 bg-blue-500 text-white font-semibold rounded-lg hover:bg-blue-600 transition-colors duration-300"  
 type="submit">{editingItemId ? 'Update' : 'Create'}</button>
          {editingItemId && <button                  className="px-6 py-3 bg-red-500 text-white font-semibold rounded-lg hover:bg-blue-600 transition-colors duration-300"  
type="button" onClick={() => setEditingItemId(null)}>Cancel</button>}
        </form>
        <ul className="social-links-list">
          {socialLinks.map((link) => (
            <li key={link._id}>
              <a href={link.url}>{link.icon}</a>
              <button                 className="px-6 py-3 bg-blue-500 text-white font-semibold rounded-lg hover:bg-blue-600 transition-colors duration-300"  
 onClick={() => handleSocialLinkEdit(link._id)}>Edit</button>
            </li>
          ))}
        </ul>
         {/* Logo Upload Form */}
         <form className="admin-form" onSubmit={logo._id ? handleLogoEdit : handleLogoUpload}>
          <input type="file" name="logo" required />
          <button type="submit">{logo._id ? 'Update Logo' : 'Upload Logo'}</button>
        </form>
        {logo.url && (
          <div className="logo-preview">
            <img src={logo.url} alt="Current Logo" />
          </div>)}
      </div>
    </div>
  </div>
</div>
</>

  );
};

export default NavPanel;
